import { render, staticRenderFns } from "./D004.vue?vue&type=template&id=af18aa62&scoped=true&"
import script from "./D004.vue?vue&type=script&lang=js&"
export * from "./D004.vue?vue&type=script&lang=js&"
import style0 from "./D004.vue?vue&type=style&index=0&id=af18aa62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af18aa62",
  null
  
)

export default component.exports